import constants from 'constants/index'

const filterUnnecessaryLifeCycles = (rmc) => {
  if (!rmc?.unnecessaryDatas) {
    return []
  }
  return rmc.unnecessaryDatas.filter(
    (unnecessaryData) =>
      unnecessaryData.dataType ===
      constants.dataProcess.UNNECESSARY_DATA_TYPE.LIFE_CYCLE,
  )
}

export default filterUnnecessaryLifeCycles
